import PlaygroundAuthType from "../../../playgroundAuthType";
import sanitizeName from "./sanitizeName";
import OAUTH_NOTE from "./oauthNote";

const getRaycastInstructions = (playground, bearerToken, mcpServerUrl) => {
  const oauthNote =
    playground.authType === PlaygroundAuthType.OAUTH ? OAUTH_NOTE : "";
  let codeSnippet = `{
    "mcpServers": {
      "${sanitizeName(playground.name)}": {     
        "command": "npx",
        "args": ["mcp-remote", "${mcpServerUrl}"]
      }
    }
  }`;

  if (playground.authType === "BEARER_TOKEN") {
    codeSnippet = `{
    "mcpServers": {
      "${sanitizeName(playground.name)}": {
        "command": "npx",
        "args": [
          "mcp-remote",
          "${mcpServerUrl}",
          "--header",
          "Authorization:\${AUTH_HEADER}"
        ],
        "env": {
          "AUTH_HEADER": "Bearer ${
            bearerToken ? bearerToken : "<YOUR_API_KEY>"
          }"
        }
      }
    }
  }`;
  }

  let result = `
${oauthNote}You can use MCP servers within Raycast to extend AI even further. MCP servers work and behave similar to AI Extensions. After installation, you can \`@-mention\` MCP servers in the root search, AI Commands, AI Chat, and Presets.

You can simply install a server with the Install Server command by filling out the form.

![](https://images.spr.so/cdn-cgi/imagedelivery/j42No7y-dcokJuNgXeA0ig/8a408967-fd5a-4a73-aac5-5d86f2b038f7/Raycast_2025-05-07_at_23.57.15/w=800,quality=90,fit=scale-down)

Set the 'Command' to <strong>npx</strong> and the 'Arguments' to <strong>mcp-remote ${mcpServerUrl}</strong>


💡 Tip: If you copy the code below to your clipboard before opening the Install Server command, Raycast will automatically prefill the form fields for you.

\`\`\`json
${codeSnippet}
\`\`\`


For further details, see [the official documentation here](https://manual.raycast.com/model-context-protocol).


`;

  return result;
};

export default getRaycastInstructions;
